import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const recommendations = css`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const avatar = css``;

export const avatars = css`
  display: flex;
  flex-direction: row-reverse;
  .${avatar} {
    width: 2rem;
    padding: 2px;
    background-color: white;
    &:not(:only-child):not(:last-child) {
      margin-left: -1rem;
    }
  }
`;

export const friendsRecommendations = css`
  background-color: ${theme.colors.peoople['gris-claro']};
  color: ${theme.colors.peoople['gris-medio']};
  padding: 0.5rem;
  display: flex;
  gap: 1rem;
  border-radius: 0.25rem;
  align-items: center;
  font-size: 14px;
`;

export const totalRecommendations = css`
  font-weight: 600;
  color: ${theme.colors.peoople['gris-medio']};
  text-align: center;
  &:not(:first-child) {
    padding: 0 0.5rem;
  }
  @media screen and (width > ${theme.sizes.screens.md}) {
    text-align: initial;
  }
`;
